import { useLocation } from "react-router-dom";
import { useState } from "react";
import { ArrowRight, Shield } from "lucide-react";
import { BRAND } from "@/lib/constants";

export default function CrmLogin() {
  const location = useLocation();
  const error = location.state?.error;
  const [loading, setLoading] = useState(false);

  const handleLogin = () => {
    setLoading(true);
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/crm";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-white dark:bg-black text-black dark:text-white">
      {/* Left brand panel */}
      <div className="relative hidden lg:block overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1732075889113-833a9670bae8?auto=format&fit=crop&w=1650&q=75"
          alt="Dubai skyline at night — Velor Advisory CRM sign-in"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/80" />
        <div className="relative h-full p-12 flex flex-col justify-between text-white">
          <img
            src={BRAND.logoWhite}
            alt="Velor Advisory logo"
            className="h-32 w-auto -ml-4 -mt-6 object-contain"
          />
          <div>
            <div className="text-[11px] tracking-overline uppercase text-white/60">Velor Advisory · CRM</div>
            <h1 className="mt-4 font-serif text-4xl md:text-5xl leading-tight max-w-md">
              Manage every enquiry, quietly and precisely.
            </h1>
          </div>
        </div>
      </div>

      {/* Right login card */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="text-[11px] tracking-overline uppercase text-black/45 dark:text-white/45 flex items-center gap-2">
            <Shield size={14} /> Private access
          </div>
          <h2 className="mt-3 font-serif text-4xl md:text-5xl leading-tight">Sign in to Velor CRM</h2>
          <p className="mt-4 text-black/60 dark:text-white/60 text-sm font-light">
            Access is restricted to authorised Velor advisors. Sign in with your Google account.
          </p>

          {error && (
            <div data-testid="login-error" className="mt-6 p-4 border border-rose-300 dark:border-rose-800 bg-rose-50 dark:bg-rose-950/40 text-rose-800 dark:text-rose-200 text-sm">
              {error}
            </div>
          )}

          <button
            onClick={handleLogin}
            disabled={loading}
            data-testid="google-signin-btn"
            className="mt-10 w-full inline-flex items-center justify-center gap-3 px-6 py-4 bg-black text-white dark:bg-white dark:text-black text-[12px] tracking-overline uppercase hover:opacity-90 transition disabled:opacity-60"
          >
            {loading ? "Redirecting…" : "Continue with Google"}
            <ArrowRight size={16} />
          </button>

          <div className="mt-10 text-xs text-black/45 dark:text-white/45 font-light">
            Not authorised? <a href="/" className="underline">Return to velor.ae</a>
          </div>
        </div>
      </div>
    </div>
  );
}
